export default function unsetFlag(name) {
  this.setVarValue(name, false);
}